import React, { useEffect } from "react";

import useStores from "@hooks/useStores";
import { observer } from "mobx-react";

import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import useStyles from "@hooks/useStyles";

const InputRadio = observer(({ question, answer, nextHandler, secondary }) => {
	const classes = useStyles("LeadFunnel");
	const { inputRadioStore: store } = useStores();
	const instance = store.findInstanceByAnswerId(answer._id);

	const onChangeHandler = (e) => {
		if (e.target.checked) instance.add(e.target.value);
		if (nextHandler && !answer.data_toggle) nextHandler();
	};

	useEffect(() => {
		store.init(question, answer);
		return () => store.reset();
	}, []);

	return (
		<React.Fragment>
			{instance && (
				<div className={secondary ? classes.inputBorder2 : classes.inputBorder}>
					<FormControlLabel
						classes={{
							root: secondary ? classes.formControl2 : classes.formControl,
						}}
						className={instance.isChecked && secondary && classes.checked}
						control={
							<Radio
								color={"primary"}
								checked={instance.isChecked}
								id={answer._id}
								value={answer.value}
								name={"answer"}
								onChange={onChangeHandler}
							/>
						}
						label={answer.value}
					/>
				</div>
			)}
		</React.Fragment>
	);
});

export default InputRadio;
